import { PortfolioFeedItem } from "@bn/api/ariva";
import { CATEGORY_BADGES, DEFAULT_BADGE, TimelineArticle } from "./types";
import { arivaInstrumentUrl, arivaNewsUrl } from "./urls";

// price_new arrives as a string; convert to a number for display.
const toNumber = (value?: string): number | undefined => {
  if (!value) return undefined;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
};

export const mapToArticle = (
  item: PortfolioFeedItem,
  images: Record<string, string | null | undefined>
): TimelineArticle => {
  const href = item.url
    ? arivaNewsUrl(item.url)
    : item.isin
      ? arivaInstrumentUrl(item.isin)
      : undefined;

  const getImg = (isin: string) => images[isin] ?? undefined;

  return {
    id: `${item.category}-${item.isin ?? item.country ?? item.title}-${
      item.date
    }`,
    categoryLabel: item.category,
    badge: CATEGORY_BADGES[item.category] ?? DEFAULT_BADGE,
    title: item.title,
    description: item.teaser,
    recommendation: item.recommendation,
    price: toNumber(item.price_new),
    isin: item.isin,
    country: item.country,
    logoUrl: item.isin ? getImg(item.isin) : undefined,
    href,
  };
};
